import React, { useRef, useEffect, useState } from "react";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";

const SORT_BY_OPTIONS = ["Instalment Payment", "Total Premium", "Total Due Today (All Fees & Ancillaries)", "Total Auto Premium"];
// Using checkboxes for Yes/No toggles; numeric inputs for fee amounts
const initialCompareInsuranceQuoteData = {
  sortBy: "",
  wayplusRtg6Month: "No",
  wayplusRtg3Month: "No",
  wayplusRoadside6Month: "No",
  wayplusRoadside3Month: "No",
  hospitalIndIndividual: "No",
  hospitalIndFamily: "No",
  telemedicine: "No",
  discountPackage: "No",
  identityTheftInd: "No",
  agencyFee: 0,
  tranzpayServiceFee: 0,
};
export default function CompareInsuranceQuotesConfig({
  compareInsuranceQuoteConfigurationList,
  state,
  getCompareInsuranceQuoteConfigurationDetails,
  loading,
}: {
  compareInsuranceQuoteConfigurationList: any;
  state: string;
  getCompareInsuranceQuoteConfigurationDetails: () => void;
  loading: boolean;
}) {
  const formRef = useRef<HTMLFormElement>(null);
  const toast = React.useRef<Toast>(null);
  const navigate = useNavigate();
  const [saveLoading, setSaveLoading] = useState(false);
  const [formData, setFormData] = useState(initialCompareInsuranceQuoteData);
  useEffect(() => {
    if (compareInsuranceQuoteConfigurationList) {
      setFormData({
        sortBy: compareInsuranceQuoteConfigurationList.sortBy ?? "",
        wayplusRtg6Month: compareInsuranceQuoteConfigurationList.wayPlusRTG6Month ?? "No",
        wayplusRtg3Month: compareInsuranceQuoteConfigurationList.wayPlusRTG3Month ?? "No",
        wayplusRoadside6Month: compareInsuranceQuoteConfigurationList.wayPlusRoadside6Month ?? "No",
        wayplusRoadside3Month: compareInsuranceQuoteConfigurationList.wayPlusRoadside3Month ?? "No",
        hospitalIndIndividual: compareInsuranceQuoteConfigurationList.hospitalIndIndividual ?? "No",
        hospitalIndFamily: compareInsuranceQuoteConfigurationList.hospitalIndFamily ?? "No",
        telemedicine: compareInsuranceQuoteConfigurationList.telemedicine ?? "No",
        discountPackage: compareInsuranceQuoteConfigurationList.discountPackage ?? "No",
        identityTheftInd: compareInsuranceQuoteConfigurationList.identityTheftInd ?? "No",
        agencyFee: compareInsuranceQuoteConfigurationList.agencyFee ?? 0,
        tranzpayServiceFee: compareInsuranceQuoteConfigurationList.tranzpayServiceFee ?? 0,
      });
    }
  }, [compareInsuranceQuoteConfigurationList]);
  const handleReset = () => {
    setFormData({
      sortBy: "",
      wayplusRtg6Month: "No",
      wayplusRtg3Month: "No",
      wayplusRoadside6Month: "No",
      wayplusRoadside3Month: "No",
      hospitalIndIndividual: "No",
      hospitalIndFamily: "No",
      telemedicine: "No",
      discountPackage: "No",
      identityTheftInd: "No",
      agencyFee: 0,
      tranzpayServiceFee: 0,
    });
  };
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked ? "Yes" : "No",
    }));
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: parseFloat(value) || 0,
    }));
  };

  const onCompareInsuranceQuotesSaveClick = () => {
    if (!state || state.trim() === "") {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "State is required.",
        life: 3000,
      });
      return;
    }

    setSaveLoading(true);

    const payload = {
      compareInsurance: true,
      sortBy: formData.sortBy,
      wayplusRtg6Month: formData.wayplusRtg6Month,
      wayplusRtg3Month: formData.wayplusRtg3Month,
      wayplusRoadside6Month: formData.wayplusRoadside6Month,
      wayplusRoadside3Month: formData.wayplusRoadside3Month,
      hospitalIndIndividual: formData.hospitalIndIndividual,
      hospitalIndFamily: formData.hospitalIndFamily,
      telemedicine: formData.telemedicine,
      discountPackage: formData.discountPackage,
      identityTheftInd: formData.identityTheftInd,
      agencyFee: formData.agencyFee,
      tranzpayServiceFee: formData.tranzpayServiceFee,
      state: state,
    };

    let data = JSON.stringify(payload);

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/compareinsurancequoteconfiguration`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        setSaveLoading(false);
        getCompareInsuranceQuoteConfigurationDetails();
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Compare insurance quotes settings saved successfully!",
          life: 3000,
        });
      })
      .catch((error: any) => {
        setSaveLoading(false);
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while saving the compare insurance quotes configuration!"}`
                : "Unknown error while saving the compare insurance quotes configuration!",
            life: 3000,
          });
        }
      });
  };
  return (
    <div>
      <div className="config-info-banner">
        <div className="config-info-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
            <line x1="12" y1="8" x2="12" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M12 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <div className="config-info-text">
          <p className="feature-bold">Compare Insurance Quotes Settings</p>
          <span className="feature-label">Configure comparison defaults and display options below.</span>
        </div>
      </div>
      <div style={{ position: "relative" }}>
       {loading && (
          <div className="driver-loading-overlay">
            <div className="driver-loading-content">
              <div className="driver-loading-spinner" />
              <p className="driver-loading-text">Loading compare insurance quotes configuration...</p>
            </div>
          </div>
        )}
        <form ref={formRef}>
          <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(220px, 1fr))", gap: "1rem" }}>
            {/* All form groups as before */}
            <div className="form-group">
              <label htmlFor="sort-by">Sort By</label>
              <select id="sort-by" className="form-input compact-select" name="sortBy" value={formData.sortBy} onChange={handleSelectChange}>
                <option value="" disabled>
                  Select sort key
                </option>
                {SORT_BY_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="agency-fee">Agency Fee</label>
              <input
                id="agency-fee"
                type="number"
                min={0}
                placeholder="Type default amount"
                className="form-input"
                name="agencyFee"
                value={formData.agencyFee}
                onChange={handleNumberChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="tranzpay-fee">Tranzpay Service Fee</label>
              <input
                id="tranzpay-fee"
                type="number"
                min={0}
                placeholder="Type default amount"
                className="form-input"
                name="tranzpayServiceFee"
                value={formData.tranzpayServiceFee}
                onChange={handleNumberChange}
              />
            </div>

            <div className="form-group form-group-horizontal">
              <label htmlFor="wayplus-rtg-6" className="ancillary-label-indent">
                Way+ RTG 6-month
              </label>
              <label className="toggle-switch">
                <input
                  id="wayplus-rtg-6"
                  type="checkbox"
                  name="wayplusRtg6Month"
                  checked={formData.wayplusRtg6Month === "Yes"}
                  onChange={handleCheckboxChange}
                />
                <span className="toggle-slider" />
              </label>
            </div>

            <div className="form-group form-group-horizontal">
              <label htmlFor="wayplus-rtg-3" className="ancillary-label-indent">
                Way+ RTG 3-month
              </label>
              <label className="toggle-switch">
                <input
                  id="wayplus-rtg-3"
                  type="checkbox"
                  name="wayplusRtg3Month"
                  checked={formData.wayplusRtg3Month === "Yes"}
                  onChange={handleCheckboxChange}
                />
                <span className="toggle-slider" />
              </label>
            </div>

            <div className="form-group form-group-horizontal">
              <label htmlFor="wayplus-roadside-6" className="ancillary-label-indent">
                Way+ Roadside 6-month
              </label>
              <label className="toggle-switch">
                <input
                  id="wayplus-roadside-6"
                  type="checkbox"
                  name="wayplusRoadside6Month"
                  checked={formData.wayplusRoadside6Month === "Yes"}
                  onChange={handleCheckboxChange}
                />
                <span className="toggle-slider" />
              </label>
            </div>

            <div className="form-group form-group-horizontal">
              <label htmlFor="wayplus-roadside-3" className="ancillary-label-indent">
                Way+ Roadside 3-month
              </label>
              <label className="toggle-switch">
                <input
                  id="wayplus-roadside-3"
                  type="checkbox"
                  name="wayplusRoadside3Month"
                  checked={formData.wayplusRoadside3Month === "Yes"}
                  onChange={handleCheckboxChange}
                />
                <span className="toggle-slider" />
              </label>
            </div>

            {/* <div className="form-group form-group-horizontal">
              <label htmlFor="hospital-ind" className="ancillary-label-indent">
                Hospital Ind Individual
              </label>
              <label className="toggle-switch">
                <input
                  id="hospital-ind"
                  type="checkbox"
                  name="hospitalIndIndividual"
                  checked={formData.hospitalIndIndividual === "Yes"}
                  onChange={handleCheckboxChange}
                />
                <span className="toggle-slider" />
              </label>
            </div>

            <div className="form-group form-group-horizontal">
              <label htmlFor="hospital-family" className="ancillary-label-indent">
                Hospital Ind Family
              </label>
              <label className="toggle-switch">
                <input
                  id="hospital-family"
                  type="checkbox"
                  name="hospitalIndFamily"
                  checked={formData.hospitalIndFamily === "Yes"}
                  onChange={handleCheckboxChange}
                />
                <span className="toggle-slider" />
              </label>
            </div>

            <div className="form-group form-group-horizontal">
              <label htmlFor="telemedicine" className="ancillary-label-indent">
                Telemedicine
              </label>
              <label className="toggle-switch">
                <input
                  id="telemedicine"
                  type="checkbox"
                  name="telemedicine"
                  checked={formData.telemedicine === "Yes"}
                  onChange={handleCheckboxChange}
                />
                <span className="toggle-slider" />
              </label>
            </div>

            <div className="form-group form-group-horizontal">
              <label htmlFor="discount-package" className="ancillary-label-indent">
                Discount Package
              </label>
              <label className="toggle-switch">
                <input
                  id="discount-package"
                  type="checkbox"
                  name="discountPackage"
                  checked={formData.discountPackage === "Yes"}
                  onChange={handleCheckboxChange}
                />
                <span className="toggle-slider" />
              </label>
            </div>

            <div className="form-group form-group-horizontal">
              <label htmlFor="identity-theft" className="ancillary-label-indent">
                Identity Theft Ind
              </label>
              <label className="toggle-switch">
                <input
                  id="identity-theft"
                  type="checkbox"
                  name="identityTheftInd"
                  checked={formData.identityTheftInd === "Yes"}
                  onChange={handleCheckboxChange}
                />
                <span className="toggle-slider" />
              </label>
            </div> */}

            
          </div>
          <div className="tab-actions">
            <button type="button" className="btn btn-primary" onClick={onCompareInsuranceQuotesSaveClick} disabled={saveLoading}>
              {saveLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
